
export default {
    main: {
        1: [
            "控えめに話をしてましたね！",
            "優しい雰囲気で話をしていましたね！",
            "大人しめに話をしていましたね！",
            "安定感のある話し方でしたね！",
            "冷静な話し方でしたね！",
        ],
        2: [
            "だいぶ熱くなっていましたね！",
            "かなり興奮していましたね！",
            "熱量がすごすぎて驚きです！",
            "熱くなりすぎで驚きです！",
            "おひとりで興奮のるつぼでしたね！",
        ],
        3: [
            "熱がこもっていて素敵でした！",
            "熱量が伝わる話し方でした！",
            "気持ちの伝わる話し方でした！",
            "こちらにはしっかり熱が伝わりました！",
            "きっと聞き手によく伝わったのでは！",
        ],
        4: [
            "とても熱量を感じました！",
            "聞き手も身を乗り出す熱量でした！",
            "思わず前のめりになる熱量でした！",
            "人を動かす熱量が込められてました！",
            "きっと聞き手も気合いが入ったはず！",
        ],
        5: [
            "みんなに熱意が伝わったのでは！",
            "聞いているこちらも熱くなりました！",
            "聞き手を動かす力のこもった話し方でした！",
            "きっと聞き手も興奮しているはず！",
            "太陽のような熱量でした！",
        ],
    },
    title: {
        1: [
            "ぬるま湯のような熱量！？",
        ],
        2: [
            "フォッサ・マグナ級の熱量！？",
        ],
        3: [
            "日だまりのような熱量！",
        ],
        4: [
            "たき火のような熱量",
        ],
        5: [
            "太陽のような熱量！",
        ],
    },
    comment: {
        1: [
            "気持ちいいんだけど、冷めるのも早い？",
        ],
        2: [
            "熱すぎて、周囲が色々大変！？",
        ],
        3: [
            "じんわりと熱が伝わる、いい感じの雰囲気！",
        ],
        4: [
            "冷えた会議にとってもうれしい、熱意がどんどん浸透！",
        ],
        5: [
            "もはや神クラス、会議になくてはならい起爆剤！",
        ],
    }
}

